import { axiosObject } from "../config";

export default function requestMobileVerification(form: any) {
  let payload = {
    type: "mobile_number",
    value: "+91" + form.value.user_identity.toLocaleLowerCase(),
  };

  return new Promise((resolve, reject) => {
    let uri = "access/request-verify-registration";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        console.log("check here res:", response);
        resolve(response.data);
      })
      .catch((errors) => {
        if (
          errors?.response?.data?.errors?.value[0] === "Value should be unique"
        ) {
          form.setErrors({ token: ["Mobile already registered!"] });
        }
        reject(errors);
      });
  });
}
